import { game } from "native";

function stsNative(msg) {
    // Intentionally sending an empty object when there is no body
    // otherwise, the sts message fails to parse
    msg.body      = JSON.stringify(msg.body || {});
    msg.headers.c = "application/json";

    return game.call("StsRequest", msg)
        .then((res) =>
            (res.bodyRaw ?
                JSON.parse(res.bodyRaw) :
                res
            )
        )
        .catch((err) => {
            const e = new Error("STS Error");

            /* program:!live */
            Object.keys(err).forEach(function(key) {
                e[key] = err[key];
            });

            e.request = msg;
            /* /program:!live */

            throw e;
        }
    );
}

// Should only get hit when using the stub...
function stsHttp(msg) {
    msg.headers.m = window.native.stats.sessionId;

    return fetch(`/stsRequest?${msg.protocol}/${msg.command}`,
        {
            method  : "post",
            body    : JSON.stringify(msg),
            headers : {
                "Content-Type" : "application/json; charset=UTF-8"
            }
        }
    )
    .then((res) => {
        if (res.status !== 200) {
            throw new Error("STS request failed");
        }

        return res.json();
    });
}

export default function stsRequest(msg) {
    if (!msg.headers) {
        msg.headers = {};
    }

    if (!msg.type) {
        msg.type = "One";
    }

    // Ensure gamecode matches the game
    msg.protocol = msg.protocol.replace(".gw2.", `.${window.native.buildInfo.gameCode}.`);

    return (GW2.config.features.cliGate) ? stsNative(msg) : stsHttp(msg);
}
